import { User } from './user.model'

export enum Visibility {
  public,
  private
}

export class Group {
  public id = ''
  public author = new User()
  public name = ''
  public description = ''
  public visibility = Visibility.public
  public users: User[] = []
  public nbMembers = 0

  cast (data: Object) {
    Object.keys(data).forEach((key) => {
      if (this.hasOwnProperty(key)) {
        switch (key) {
          case 'visibility':
            const visibility: string = data[key]
            this[key] = Visibility[visibility] || Visibility.public
            break
          case 'users':
            this.users = data[key].map((user) => new User().cast(user))
            break
          case 'author':
            this[key] = new User().cast(data[key])
            break
          default:
            this[key] = data[key]
            break
        }
      }
    })

    return this
  }

  getVisibilityLabel (label) {
    const visibility = typeof label !== 'undefined' ? label : this.visibility
    switch (visibility) {
      case Visibility.public:
        return 'public'
      case Visibility.private:
        return 'privé'
      default:
        return 'public'
    }
  }

  isPrivate () {
    return this.visibility === Visibility.private
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/group.model.ts